import {createSlice} from "@reduxjs/toolkit";

const initialAspirantetate = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    aspiranteInformacion: undefined,
    error: null
  };

  export const callTypes = {
    list: "list",
    action: "action"
  };

  export const aspiranteSlice=createSlice({
      name:"aspirante",
      initialState:initialAspirantetate,
      reducers:{
        catchError:(state,action)=>{
            state.error = action.payload.error.clientMessage;
            state.aspiranteInformacion=undefined;
            if(action.payload.callType===callTypes.list){
                state.listLoading=false;
            }else{
                state.actionsLoading=false;
            };
        },
        starCall:(state,action)=>{
            state.error=null;
            if(action.payload.callType===callTypes.list){
                state.listLoading=true;
            }else{
                state.actionsLoading=true;
            };
        },
        aspiranteFetched:(state,action)=>{
            state.actionsLoading=false;
            state.aspiranteInformacion=action.payload.aspiranteInformacion;
            state.error=null;
        },
        reiniciarDatos:(state,action)=>{
            state.actionsLoading=false;
            state.aspiranteInformacion=undefined;
            state.error=null;
        }
      }
  });